import React, { useEffect, useRef, useState } from "react";

// Détecte automatiquement qu'un nouveau déploiement existe et propose à
// l'utilisateur de rafraîchir — sans le forcer. Indispensable vu nos mises à
// jour fréquentes + le gros trafic depuis le navigateur intégré de Facebook,
// qui sert très volontiers de vieilles versions.
//
// Principe : CRA renomme le bundle principal à chaque build (main.<hash>.js) et
// liste ce nom dans /asset-manifest.json. On compare le bundle ACTUELLEMENT
// chargé au dernier publié (re-récupéré sans cache au retour sur l'onglet /
// périodiquement). S'ils diffèrent → un déploiement plus récent est en ligne.
// Ajouté 2026-05-31.
const fileName = (s) => (s || "").split("?")[0].split("/").pop();

export default function VersionWatcher() {
  const [stale, setStale] = useState(false);
  const loadedMain = useRef(null);

  useEffect(() => {
    // Nom du bundle principal effectivement chargé dans cette page.
    const tag = document.querySelector('script[src*="/static/js/main."]');
    loadedMain.current = tag ? fileName(tag.getAttribute("src")) : null;
    if (!loadedMain.current) return; // dev (pas de bundle hashé) → on ne fait rien

    let stopped = false;
    const check = async () => {
      if (stopped || document.hidden) return;
      try {
        const res = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const m = await res.json();
        const latest = fileName(m?.files?.["main.js"]);
        if (latest && loadedMain.current && latest !== loadedMain.current) {
          setStale(true);
        }
      } catch { /* hors-ligne / 404 : on réessaiera */ }
    };

    check();
    const iv = setInterval(check, 4 * 60 * 1000); // toutes les 4 min
    const onVisible = () => { if (!document.hidden) check(); };
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      stopped = true;
      clearInterval(iv);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  if (!stale) return null;
  const isEN = typeof navigator !== "undefined" && /^en/i.test(navigator.language || "");

  return (
    <div style={{
      position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 9999,
      background: "#C9A84C", color: "#07111F", padding: "12px 16px",
      display: "flex", alignItems: "center", justifyContent: "center", gap: 14,
      fontFamily: "Lato, system-ui, sans-serif", boxShadow: "0 -6px 24px rgba(0,0,0,0.4)",
    }}>
      <span style={{ fontWeight: 700, fontSize: 14 }}>
        {isEN ? "A new version is available." : "Une nouvelle version est disponible."}
      </span>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: "#07111F", color: "#E8DCC8", border: "none", borderRadius: 10,
          padding: "8px 16px", fontWeight: 800, fontSize: 13.5, cursor: "pointer",
        }}
      >
        {isEN ? "Refresh" : "Rafraîchir"}
      </button>
    </div>
  );
}
